import { CountDownAction, CountDownActionTypes } from './count-down.actions';

export const COUNTDOWN_FEATURE_KEY = 'countDown';

/**
 * Interface for the 'CountDown' data used in
 *  - CountDownState, and
 *  - countDownReducer
 *
 *  Note: replace if already defined in another module
 */

export interface CountDownState {
  countDown: number;
}

export interface CountDownPartialState {
  readonly [COUNTDOWN_FEATURE_KEY]: CountDownState;
}

export const initialState: CountDownState = {
  countDown: 0
};

export function countDownReducer(
  state: CountDownState = initialState,
  action: CountDownAction
): CountDownState {
  switch (action.type) {
    case CountDownActionTypes.UPDATE_COUNTER:
      return { countDown: action.payload };

    case CountDownActionTypes.CLEAR_COUNTER:
      return initialState;
  }
  return state;
}
